import { render } from "./AsideClima.vue?vue&type=template&id=c8a21c4a"
import script from "./AsideClima.vue?vue&type=script&lang=js"
export * from "./AsideClima.vue?vue&type=script&lang=js"

import "./AsideClima.vue?vue&type=style&index=0&id=c8a21c4a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__